import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import ListCreator from '../../components/Lists/listCreator'
import { getCall } from '../helpers/componentApiHelpers/getCall'
import '../main.css'

class BoyutlarList extends Component {

    constructor(props){
        super(props)
        this.state = {
            data: "",
            dataCame: false
        }
    }

    async componentDidMount() {
        try{
            const getData = await getCall("/size/getall")
            await this.setState({dataCame: true, data: getData.data})
        }
        catch(err){
            console.log(err)
        }
    }

    render() {

        return (
            <React.Fragment>
                <HeaderLine header="Boyutlar" />
                <button onClick={() => this.props.history.push("/boyutlarCreate")} className="blue-button add-new-button">Yeni Ekle</button>
                <ListCreator
                    data={this.state.data}
                    dataInfo={[
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "sizeName", header: "Boyut Açıklaması" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "size", header: "Boyut Cm" },
                    ]}
                    buttons={{
                        className: "col-2",
                        buttonData: [
                            { name: "Düzenle", func: (d) => {this.props.history.push("/boyutlarCreate/" + d._id)} },
                            { name: "Detay", func: (d) => {this.props.history.push("detay/boyutlarDetay/" + d._id)} },
                            { name: "Sil" }
                        ]
                    }}
                    dataCame={this.state.dataCame}
                    endPoint="/size"
                />
            </React.Fragment>
        )
    }
}

export default BoyutlarList